import axios from 'axios';

export const laborService = {
  getLabor: (taskId) => axios.get('/labor', { auth: true, params: { task: taskId } }),
  createLabor: (data) => axios.post('/labor', data, { auth: true }),
  updateLabor: (id, data) => axios.patch(`/labor/${id}`, data, { auth: true }),
  deleteLabor: (id) => axios.delete(`/labor/${id}`, { auth: true }),
  getBulkLabor: (taskIds) => axios.get('/labor/bulk', { auth: true, params: { tasks: taskIds.join(',') } }),
  reorderLabor: (items) => axios.patch('/labor/reorder', { items }, { auth: true }),
};
